import { useTranslation } from 'react-i18next';

import { SidebarMenuBadge } from '@nucleus-commerce/ui/components/sidebar';

import { useApplicationCounts } from '../hooks/use-application-counts';
import { unreadCount } from '../schemas/application-rules';

/** New, confirmed applications waiting for someone on the platform team; hidden at zero. */
export function ApplicationsNavBadge() {
  const { t } = useTranslation('applications');
  const counts = useApplicationCounts();
  const count = unreadCount(counts.data);
  if (count === 0) return null;
  return (
    <SidebarMenuBadge
      className="bg-primary text-primary-foreground rounded-full px-1.5 text-[11px]"
      aria-label={t('navBadge', { count })}
    >
      {count > 99 ? '99+' : count}
    </SidebarMenuBadge>
  );
}
